// extracted by mini-css-extract-plugin
module.exports = {"ChallengesCard":"ChallengesCard_ChallengesCard__76jc7","Content":"ChallengesCard_Content___HZiJ","Joined":"ChallengesCard_Joined__8g_0I"};